export default {
  firestorePath: 'playersFirestore',
  firestoreRefType: 'collection',
  moduleName: 'playersFirestore',
  statePropName: 'data',
  namespaced: true
}
